// ICT-1 / ICT-8 "Responses" — what a solicitor's or issuer's reply to one of
// our material follow-ups says. Rule-based (never an LLM call), pure. The
// FOLLOW_UP_REPLY workflow turns the read into the SOP's next step, and the
// person can correct the read before approving.

export type ReplyKind =
  | 'material_sent' | 'dates_changing' | 'opted_out' | 'pdf_attached'
  | 'handling_this_year' | 'not_handling'
  | 'material_not_needed' | 'pod_requested' | 'unclear';

export const REPLY_KIND_LABEL: Record<ReplyKind, string> = {
  material_sent: 'Material was sent',
  dates_changing: 'Meeting cancelled, postponed or on hold',
  opted_out: 'Canadian issuer opted out of US distribution',
  pdf_attached: 'PDFs attached',
  handling_this_year: 'Handling this year\'s job',
  not_handling: 'Not handling this year\'s job',
  material_not_needed: 'Shorted material isn\'t needed',
  pod_requested: 'Asks us to print on demand',
  unclear: 'Unclear, needs a person',
};

// Order matters: "not handling" before "handling", and an opt-out or date
// change outranks a PDF that happens to be attached to the same reply.
export function readReply(text: string): ReplyKind {
  const t = text.toLowerCase();
  if (/opted out|opted-out/.test(t)) return 'opted_out';
  if (/not handling|no longer handling|not representing/.test(t)) return 'not_handling';
  if (/we are handling|we're handling|are handling (the|this)/.test(t)) return 'handling_this_year';
  if (/postpone|cancel|on hold|dates are changing/.test(t)) return 'dates_changing';
  // ICT-13 shortage answers.
  if (/(isn't|is not|aren't|are not|not) needed|don't need|do not need/.test(t)) return 'material_not_needed';
  if (/print on demand|\bpod\b|print the .* sets/.test(t)) return 'pod_requested';
  if (/\bpdfs?\b|attached/.test(t)) return 'pdf_attached';
  if (/mailed|shipped|was sent|in transit/.test(t)) return 'material_sent';
  return 'unclear';
}

export function readTrackingNumber(text: string): string | null {
  const m = text.match(/tracking[^A-Z0-9]*([A-Z0-9]{10,})/i);
  return m ? m[1] : null;
}
